<div #notes>
    <button type="button" class="button ghost__button notes__button {{notesButtonClass}}"
        (click)="toggleNotesDialog()">
        <svg-icon name="notes"></svg-icon>
        <span class="ml-3">Notes</span>
    </button>

    <div class="notes-dialog" *ngIf="notesDialogVisible">
        <div class="c-modal-header__wrapper">
            <ng-container *ngIf="!allNotes">
                <div class="c-modal-header__backBtn" (click)="toggleAllNotes($event);">
                    <svg-icon name="big-arrow-left" svgClass="svg__image"></svg-icon>
                    <span>See all</span>
                    <span class="px-1">{{allNoteCount}}</span>
                    <span>notes</span>
                </div>
                <h4 class="c-modal-header__title">
                    <span class="text-capitalize">{{notePageName}}</span> notes
                    <span class="color--light--gray">{{noteCount}}</span>
                </h4>
            </ng-container>
            <ng-container *ngIf="allNotes">
                <div class="c-modal-header__backBtn">
                    <svg-icon name="big-arrow-left" svgClass="svg__image" (click)="toggleAllNotes($event);"></svg-icon>
                    <span class="all-notes">All Notes <span class="color--light--gray">{{allNoteCount}}</span></span>
                </div>
            </ng-container>
        </div>

        <div class="notes-modal__item">

            <div class="notes-modal__itemGroup custom__scroll">

                <ng-container *ngIf="!allNotes">
                    <div class="note" *ngFor="let note of notesList; index as i">
                        <div class="content">
                            <div class="title-group">
                                <div class="button" dropdown placement="bottom right">
                                    <svg-icon name="options" dropdownToggle></svg-icon>
                                    <div id="menu-dropdown" *dropdownMenu role="menu"
                                        class="dropdown__container dropdown-menu dropdown-menu-right dropdown__action">
                                        <div role="menuitem">
                                            <a class="dropdown-item" (click)="editNote(i, note)">
                                                <span>Edit note</span>
                                            </a>
                                        </div>
                                        <div role="menuitem">
                                            <a class="dropdown-item" (click)="deleteNote($event, note.ID, i)">
                                                <span class="text-danger">Delete note</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="title">
                                    <span class="title-name">{{note?.CREATED_BY?.NAME_FIRST}}
                                        {{note?.CREATED_BY?.NAME_LAST}}</span>
                                    <span class="date">{{note.CREATED_FORMATTED}}</span>
                                </div>
                            </div>
                            <ng-container *ngIf="editIndex !== i">
                                <span class="comment-text">{{note.TEXT}}</span>
                            </ng-container>
                            <ng-container *ngIf="editMode && editIndex == i">
                                <textarea #editTextArea restrictFirstSpace class="chat-text custom__scroll" rows="5" [innerHTML]="note.TEXT"
                                    [(ngModel)]="note.TEXT" placeholder="Add a note"></textarea>

                                <div class="c-modal-footer__wrapper pl-0">
                                    <div class="c-modal-footer__policyCheck">
                                        <label class="checkbox m-0">
                                            <input class="checkbox__input" type='checkbox' name="updateNoteAttach"
                                                id="updateNoteAttach" [value]="true" [checked]="note.INCLUDE_IN_REPORT"
                                                (change)="note.INCLUDE_IN_REPORT = !note.INCLUDE_IN_REPORT;" />
                                            <div class="checkbox__data">
                                                <div class="checkbox__indicator"></div>
                                                <p class="checkbox__text"
                                                    [popover]="'Clicking this box will include an addendum in your final report with this note.'"
                                                    triggers="mouseenter:mouseleave" placement="top">
                                                    Include this note in the PDF Report
                                                </p>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="c-modal-footer__buttonGroup">
                                        <button class="button secondary__button mr-2 border-0"
                                            id="notes-new-attach-current-cancel" type="button"
                                            (click)="clearEdit($event, note)">
                                            Cancel
                                        </button>
                                        <button id="notes-new-attach-current-save" class="button primary__button"
                                            type="button" (click)="updateNoteSave($event)" [disabled]="!note.TEXT">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="pin-frame" *ngIf="note.PAGE">
                                <span class="include-text">{{note.PAGE.NAME}}</span>
                                <div class="pin" *ngIf="note.INCLUDE_IN_REPORT">
                                    <svg-icon name="pin"></svg-icon>
                                </div>
                            </div>
                        </div>
                        <div class="photo">
                            <img class="rounded-circle" [src]="note?.CREATED_BY?.THUMBNAIL_IMAGE" width="50" height="50"
                                onerror="this.src='../../../../../assets/images/profilePhoto.jpg';" alt="...">
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="allNotes">
                    <div class="note" *ngFor="let note of allNotesList; index as i">
                        <div class="content">
                            <div class="title-group">
                                <div class="button" dropdown placement="bottom right">
                                    <svg-icon name="options" dropdownToggle></svg-icon>
                                    <div id="menu-dropdown" *dropdownMenu role="menu"
                                        class="dropdown__container dropdown-menu dropdown-menu-right dropdown__action">
                                        <div role="menuitem">
                                            <a class="dropdown-item" (click)="editNote(i, note)">
                                                <span>Edit note</span>
                                            </a>
                                        </div>
                                        <div role="menuitem">
                                            <a class="dropdown-item" (click)="deleteNote($event, note.ID, i)">
                                                <span class="text-danger">Delete note</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="title">
                                    <span class="title-name">{{note?.CREATED_BY?.NAME_FIRST}}
                                        {{note?.CREATED_BY?.NAME_LAST}}</span>
                                    <span class="date">{{note.CREATED_FORMATTED}}</span>
                                </div>
                            </div>
                            <ng-container *ngIf="editIndex !== i">
                                <span class="comment-text">{{note.TEXT}}</span>
                            </ng-container>
                            <ng-container *ngIf="editMode && editIndex == i">
                                <textarea #editTextArea restrictFirstSpace class="chat-text custom__scroll" rows="5" [innerHTML]="note.TEXT"
                                    [(ngModel)]="note.TEXT" placeholder="Add a note"></textarea>

                                <div class="c-modal-footer__wrapper pl-0">
                                    <div class="c-modal-footer__policyCheck">
                                        <label class="checkbox m-0">
                                            <input class="checkbox__input" type='checkbox' name="updateNoteAttach"
                                                id="updateNoteAttach" [value]="true" [checked]="note.INCLUDE_IN_REPORT"
                                                (change)="note.INCLUDE_IN_REPORT = !note.INCLUDE_IN_REPORT;" />
                                            <div class="checkbox__data">
                                                <div class="checkbox__indicator"></div>
                                                <p class="checkbox__text"
                                                    [popover]="'Clicking this box will include an addendum in your final report with this note.'"
                                                    triggers="mouseenter:mouseleave" placement="top">
                                                    Include this note in the PDF Report
                                                </p>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="c-modal-footer__buttonGroup">
                                        <button class="button secondary__button mr-2 border-0"
                                            id="notes-new-attach-current-cancel" type="button"
                                            (click)="clearEdit($event, note)">
                                            Cancel
                                        </button>
                                        <button id="notes-new-attach-current-save" class="button primary__button"
                                            type="button" (click)="updateNoteSave($event)" [disabled]="!note.TEXT">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="pin-frame" *ngIf="note.PAGE">
                                <span class="include-text">{{note.PAGE.NAME}}</span>
                                <div class="pin" *ngIf="note.INCLUDE_IN_REPORT">
                                    <svg-icon name="pin"></svg-icon>
                                </div>
                            </div>
                        </div>
                        <div class="photo">
                            <img class="rounded-circle" [src]="note?.CREATED_BY?.THUMBNAIL_IMAGE" width="50" height="50"
                                onerror="this.src='../../../../../assets/images/profilePhoto.jpg';" alt="...">
                        </div>
                    </div>
                </ng-container>

            </div>

        </div>

        <div class="c-modal-body__wrapper">
            <div class="c-modal-body__content">
                <textarea restrictFirstSpace class="chat-text custom__scroll" rows="5" placeholder="Add a note" [(ngModel)]="newNote.TEXT"
                    #newNoteText="ngModel" id="newNoteText" name="newNoteText"></textarea>
            </div>
        </div>

        <div class="c-modal-footer__wrapper">

            <div class="c-modal-footer__policyCheck">
                <label class="checkbox m-0">
                    <input class="checkbox__input" type='checkbox' name="newNoteAttach" id="newNoteAttach"
                        [value]="true" [checked]="newNote.INCLUDE_IN_REPORT"
                        (change)="newNote.INCLUDE_IN_REPORT = !newNote.INCLUDE_IN_REPORT;" />
                    <div class="checkbox__data">
                        <div class="checkbox__indicator"></div>
                        <p class="checkbox__text"
                            [popover]="'Clicking this box will include an addendum in your final report with this note.'"
                            triggers="mouseenter:mouseleave" placement="top">
                            Include this note in the PDF Report
                        </p>
                    </div>
                </label>
            </div>

            <div class="c-modal-footer__buttonGroup">
                <button class="button secondary__button mr-2 border-0" *ngIf="newNote.TEXT" (click)="clearNewNote()">
                    Cancel
                </button>
                <button class="button primary__button" [disabled]="!newNote.TEXT" (click)="postNewOrEditNote()">
                    Post
                </button>
            </div>

        </div>

    </div>
</div>
